<template>
  <section class="order-dashbord-warp">
        <h2 class="section-title">주문현황</h2>

        <div class="order-dashbord">
            <div class="dashbord-box" @click.stop="scrollToFailureTarget">
                <h3 class="dashbord-title">발송실패</h3>
                <div class="dashbord-counter color-warning">{{vuexStatusCntObj.totalFailCnt}}건</div>
                <div class="dashbord-link">실패내역 확인 
                    <svg class="i-chevrons" width="5" height="9" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 7.93915L0.758355 8.6543L5 4.6543L0.758355 0.654297L0 1.36945L3.48329 4.6543L0 7.93915Z" fill="#333333"/>
                    </svg>
                </div>
            </div>
            <div class="dashbord-box" @click.stop="scrollToBookingTarget">
                <h3 class="dashbord-title">발송예약</h3>
                <div class="dashbord-counter color-primary-dark">{{vuexStatusCntObj.totalBookingCnt}}건</div>
                <div class="dashbord-link">예약내역 확인 
                    <svg class="i-chevrons" width="5" height="9" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 7.93915L0.758355 8.6543L5 4.6543L0.758355 0.654297L0 1.36945L3.48329 4.6543L0 7.93915Z" fill="#333333"/>
                    </svg>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState } from 'vuex';
export default {
    data(){
        return{
            
        }
    },

    mounted(){
        
    },

    computed: {
        ...mapState({
            vuexStatusCntObj: state => state.orderHistoryStore.vuexStatusCntObj,
        }),
    },

    watch: {
                
    },

    methods: {
        scrollToFailureTarget(){
            this.$parent.scrollToTarget('#resultControls');
            this.$emit('updateDashboardStatus', 'FAIL');
        },
        scrollToBookingTarget(){
            this.$parent.scrollToTarget('#resultControls');
            this.$emit('updateDashboardStatus', 'BOOKING');
        },
    }
}
</script>

<style lang="scss" scoped>

@import '@/assets/css/orderhistory.scss';
.order-dashbord-warp{
    padding: var(--section-pdy) 0;
}
.order-dashbord{
    display: flex;
    justify-content: space-between;
    gap: var(--compo-form-inline-pd);

    @media (min-width: 768px) {
        gap: 16px;
    }
    @media (min-width: 768px) {
        gap: 24px;
    }

    .dashbord-box{
        box-shadow: var(--box-shadow);
        border-radius: var(--border-radius);
        flex: 1;
        padding: var(--compo-form-pd);
        cursor: pointer;

        .dashbord-title{
            font-size: var(--label-font-size);
            font-weight: 400;
        }

        .dashbord-counter{
            font-size: 28px;
            margin: 20px 0;
            font-weight: 500;
            text-align: center;

            @media (min-width: 768px) {
                font-size: 36px;
            }
        }

        .dashbord-link{
            font-size: 14px;
            color: var(--gray-40);
            display: flex;
            align-items: center;
            gap: 4px;

            @media (min-width: 768px) {
                font-size: 15px;
            }
        }
    }
}
</style>